module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('span', {
    staticClass: "db-breadcrumb-loc"
  }, [_vm._v("位置：")]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(item) {
    return _c('el-breadcrumb-item', {
      attrs: {
        "to": item
      }
    }, [_vm._v("\n    " + _vm._s(item.name) + "\n  ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6966bbf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb.vue
// module id = 561
// module chunks = 2